import React, { useEffect, useState } from 'react'
import A4Page from '../A4Page'
import TopDetail from '../TopDetail'
import Page1 from './Page1'
import PageKall from './PageKall'
import PageKallLittle from './PageKallLittle'
import { ReactComponent as Zaraön } from '../../../../../assets/Varlık2.svg'
import useOrderStore from 'store/client/orderStore'
import { IoTriangleOutline } from 'react-icons/io5'
import { IoTriangle } from 'react-icons/io5'
import { ReactComponent as ZaraBom } from '../../../../../assets/DD.svg'
import { ReactComponent as ZaraBomRed } from '../../../../../assets/DDRED.svg'
import { ReactComponent as AUDDOLAR } from '../../../../../assets/DDRED.svg'
import { ReactComponent as ZaraAcc } from '../../../../../assets/zaraaccess01.svg'
import { ReactComponent as ZaraAccLinge } from '../../../../../assets/linnngee.svg'
import { ReactComponent as ZaraAccEmty } from '../../../../../assets/accesemty.svg'
import { ReactComponent as ZaraAccLin } from '../../../../../assets/accesslin.svg'
import { ReactComponent as CardFront } from '../../../../../assets/waist/waistback.svg';
import { ReactComponent as CardFront3292 } from '../../../../../assets/waist/3292backwaist.svg';
import { ReactComponent as WTZCAL0 } from '../../../../../assets/waist/WTZCALL002.svg';

import { ReactComponent as ZaraFscrrkall } from '../../../../../assets/waist/fscrrkall.svg'
import { ReactComponent as ZaraFsctmkall } from '../../../../../assets/waist/fsctmkall.svg'
import { ReactComponent as ZaraFsctmpaperkall } from '../../../../../assets/waist/fsctmpaperkall.svg'

import { ReactComponent as CardDeneme } from '../../../../../assets/waist/waistemty.svg';
import { ReactComponent as CardTry1 } from '../../../../../assets/cleanedtry.svg';
import requests from 'service/api'


const loadSVG = async (code, referenceWidth,referenceHeight) => {
  try {
    console.log(`[loadSVG] Gelen kod: ${code}`);

    if(code==="BACK"){
      return null;
    }
    
    const response = await requests.order.getBrandSvg(code, { type: 'belt' });

    // SVG string'ini React component'ine çevir
    let svgString = response.data;
    
    // SVG string'ine viewport ekle
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgString, 'image/svg+xml');
    const svgElement = doc.querySelector('svg');
    
    if (svgElement) {
      // Path elementlerini temizle
      const pathElements = svgElement.querySelectorAll('path');
      pathElements.forEach(path => {
        const fillColor = path.getAttribute('fill');
        
        // #f2eeeb rengini kontrol et
        if (fillColor === '#f2eeeb') {
          path.parentNode.removeChild(path);
          console.log('#f2eeeb renkli path elementi kaldırıldı');
          return;
        }
        
        // RGB değerlerini parse et
        if (fillColor && fillColor.startsWith('rgb(')) {
          const rgbValues = fillColor
            .replace('rgb(', '')
            .replace(')', '')
            .split(',')
            .map(val => parseFloat(val.trim().replace('%', '')));
          
          // Hedef RGB değerleri ve tolerans
          const targetRGB = [95.036316, 93.591309, 92.422485];
          const tolerance = 1; // %1 tolerans
          
          // RGB değerlerinin tolerans aralığında olup olmadığını kontrol et
          const isInRange = rgbValues.every((val, index) => {
            const target = targetRGB[index];
            return val >= target - tolerance && val <= target + tolerance;
          });
          
          if (isInRange) {
            path.parentNode.removeChild(path);
            console.log('Belirli renk aralığındaki path elementi kaldırıldı');
          }
        }
      });
      
      // Mevcut viewBox'ı koru
      
      // Width ve height ekle
      svgElement.setAttribute('width', `${referenceWidth}mm`);
      svgElement.setAttribute('height', `${referenceHeight}mm`);

      // Güncellenmiş SVG string'ini al
      svgString = new XMLSerializer().serializeToString(doc);
    }

    return () => (
      <div style={{ width: `${referenceWidth}mm`, height: `${referenceHeight}mm`, position: "relative" }} dangerouslySetInnerHTML={{ __html: svgString }} />
    );
  } catch (error) {
    console.error(`[loadSVG] SVG yüklenemedi. Kod: ${code}, Hata:`, error);
    alert("hata verdi");

    return null;
  }
};

const renderDiv = (referenceCode, referenceWidth) => {
  let style = {
    width: "50.2mm",
    height: "102mm",
    position: "absolute",
    top: 0.4,
    left: -0.4,
    zIndex: 36,
    opacity: "1",
  };

  if (referenceCode.includes("CALL") && referenceWidth === 50) {
    style.width = "50.2mm";
    style.height = "102.2mm";
  } else if (referenceCode.includes("KALL") && referenceWidth === 50) {
    style.width = "50.2mm";
    style.height = "102.2mm";
  } else if (referenceCode.includes("KALL") && referenceWidth === 32) {
    style.width = "32.2mm";
    style.height = "92.1mm";
    style.top=0;  
  }

  return (
    <div style={style}>
      <div style={{ width: style.width, height: style.height, border: style.border }}></div>
    </div>
  );
};

const CardComponent = ({ referenceCode, referenceWidth,data,selectedFscType }) => {
  const FSC_COMPONENTS = {
    fscrr: { component: ZaraFscrrkall, width: "4.73mm", height: "7.427mm" },
    fsctm: { component: ZaraFsctmkall, width: "4.855mm", height: "7.724mm" },
    fsctmpaper: { component: ZaraFsctmpaperkall, width: "6.6mm", height: "9.204mm" },
  };
  const FSC_POSITIONS50 = {
    fscrr: { bottom: 12, left: 12.80, fontsize: "2.96px", fontweight: "normal" },
    fsctm: { bottom: 12.5, left: 12.80, fontsize: "2.96px", fontweight: "normal" },
    fsctmpaper: { bottom: 12, left: 16.2, fontsize: "3.59px", fontweight: 900 },
  };
  const FSC_POSITIONS32 = {
    fscrr: { bottom: 55.2, left: 25, fontsize: "2.96px", fontweight: "normal" },
    fsctm: { bottom: 54.7, left: 25, fontsize: "2.96px", fontweight: "normal" },
    fsctmpaper: { bottom: 54.6, left: 28.2, fontsize: "3.59px", fontweight: 900 },
  };
  const SelectedComponent = FSC_COMPONENTS[selectedFscType];
  const position50 = FSC_POSITIONS50[selectedFscType] || { 
    bottom: 11, 
    left: 12.80, 
    fontsize: "2.96px", 
    fontweight: "normal" 
  }; //
  const position32 = FSC_POSITIONS32[selectedFscType] || { 
    bottom: 55.2, 
    left: 25, 
    fontsize: "2.96px", 
    fontweight: "normal" 
  }; //

  if (referenceCode.includes("KALL") && referenceWidth === 50) {
    return (
      <div
        style={{
          width: "50.2mm",
          height: "102.2mm",
          border: "1px solid transparent",
          position: "absolute",
          top: 0,
          left: 5,
        }}
      >
               <div style={{ position: 'absolute', bottom: 18, right: 16.6 }}>
               {SelectedComponent && (
  <SelectedComponent.component
    width={SelectedComponent.width}
    height={SelectedComponent.height}
  />
)}
</div>
   <div
  style={{
    position: 'absolute',
    bottom: position50.bottom,
    right: position50.left,
    letterSpacing: "0.15px"
  }}
>          <span className='helve-roman' style={{fontSize:position50.fontsize,color:"#c4c4c6",fontWeight:position50.fontWeight}}>
          {data.company?.fsc}
          </span>
          </div>

      <div style={{width:"50.2mm",height:"102.2mm",border:"1px solid #898A8D",position:"absolute",top:0,left:5}}></div>
        <CardFront width="52.9mm" height="102.1mm" />
      </div>
    );
  } else if (referenceCode.includes("KALL") && referenceWidth === 32) {
    return (
      <div
        style={{
          width: "32.2mm",
          height: "92.2mm",
          border: "1px solid transparent",
          position: "absolute",
          top: 0,
          left: 5,
        }}
      >
              <div style={{ position: 'absolute', bottom: 62, right: 28.6 }}>
              {SelectedComponent && (
  <SelectedComponent.component
    width={SelectedComponent.width}
    height={SelectedComponent.height}
  />
)}
</div>
     <div
  style={{
    position: 'absolute',
    bottom: position32.bottom,
    right: position32.left,
    letterSpacing: "0.15px",
    marginBottom:1
  }}
>          <span className='helve-roman' style={{fontSize:position32.fontsize,color:"#c4c4c6",fontWeight:position32.fontWeight}}>
          {data.company?.fsc}
          </span>
          </div>

        <CardFront3292 width="32.9mm" height="92.1mm" />
      </div>
    );
  } else if (referenceCode.includes("CALL") && referenceWidth === 50) {
    return (
      <div
        style={{
          width: "50.2mm",
          height: "102.2mm",
          border: "1px solid transparent",
          position: "absolute",
          top: 0,
          left: 5,
        }}
      >
             <div style={{ position: 'absolute', bottom: 18, right: 16.6 }}>
             {SelectedComponent && (
  <SelectedComponent.component
    width={SelectedComponent.width}
    height={SelectedComponent.height}
  />
)}
</div>

<div
  style={{
    position: 'absolute',
    bottom: position50.bottom,
    right: position50.left,
    letterSpacing: "0.15px"
  }}
>          <span className='helve-roman' style={{fontSize:position50.fontsize,color:"#c4c4c6",fontWeight:position50.fontWeight}}>
          {data.company?.fsc}
          </span>
          </div>

      <div style={{width:"50.2mm",height:"102.2mm",border:"1px solid #898A8D",position:"absolute",top:0,left:5}}></div>
        <CardFront width="52.9mm" height="102.1mm" />
      </div>
      
    );
  } else {
    return null; // Eğer hiçbir koşul sağlanmazsa boş döndür
  }
};
const BeltKnifeMain = ({ data, selectColor, tab,bicakIziParams }, ref) => {
  const department = data.department
  const [brand, category, subCategory] = department.split(' / ')
  const [SouthAmerica, setSouthAmerica] = useState(false)
  const [loading, setLoading] = useState(true);
  const [CardBackBack, setCardBackBack] = useState(null);
  const [shouldRender, setShouldRender] = useState(false);
  const [RefCode, setRefCode] = useState('');
  const [RefWidth, setRefWidth] = useState(0);
  const [hasRefreshed, setHasRefreshed] = useState(false);
  const [fscToLogo, setfscToLogo] = useState("var");

  const selectedFscType = data.company?.fsctype;
  const selectedFscTopLogo = data.company?.fsctoplogo;


  const { referance } = useOrderStore()
console.log("paramssssssss geldiii",bicakIziParams)
  const [harmacn, setHarmacn] = useState(false) // harmacn state'i

  useEffect(() => {
    if (data.company?.fsctoplogo) {
      setfscToLogo(data.company?.fsctoplogo);
 
    }
  }, [data.company?.fsctoplogo]);


  useEffect(() => {
    console.log("[useEffect - referance] referance değişti:", referance);

    if (referance?.code) {
      console.log("[useEffect - referance] Yükleniyor: ", referance.code);
      setRefCode(referance?.code)
      setRefWidth(referance?.width)
      loadSVG(referance.code, referance.width,referance.height)
        .then((component) => {
          console.log("[useEffect - referance] Yüklenen SVG Component:", component);
          setCardBackBack(() => component);
        })
        .catch((error) => {
          console.error("[useEffect - referance] SVG yüklenirken hata:", error);
        });
    }
  }, [referance]);

  useEffect(() => {
    if (referance) {
      setShouldRender(true);
 
    }
  }, [referance]);


  const isBlack = referance?.backgroundColor === 'B'


  

  // item.amount > 0 koşulunu sağlayan öğeleri filtrele ve her 8 öğede bir grupla



  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} ref={ref}>
      <div style={{ 
        width: '50cm', 
        height: '35cm', 
        position: 'relative', 
        backgroundColor: 'white',
        paddingLeft: '25mm',
        paddingRight: '5mm',
        paddingTop: '29mm',
        paddingBottom: '13mm',
        boxSizing: 'border-box'
      }}>
        {bicakIziParams ? (
          (() => {
            // Etiketleri oluştur
         const allLabels = [];
            bicakIziParams.forEach((param) => {
              const matchedSizeData = data.beltLabel[selectColor].sizes.find(
                size => size.sCode === param.sizeCode
              );
              if (matchedSizeData) {

                const filteredIndo = data.beltLabel[0].sizes.filter(item => item.amount !== '');
                console.log("filteredIndo",filteredIndo);
                const matchedIndex = filteredIndo.findIndex(size => size.sCode === param.sizeCode);
                console.log("param",param);
                for (let i = 0; i < param.value; i++) {
                  allLabels.push({
                    type: param.type,
                    value: 1,
                    sizeData: matchedSizeData,
                    inx: matchedIndex !== -1 ? matchedIndex : 0
                  });
                }
              }
            });

            // Grid ayarları
            const gridWidth = 450; // mm
            const gridHeight = 306; // mm
            const labelWidth = 50; // mm
            const labelHeight = 102; // mm

            // Satır ve sütun sayısı
            const columns = Math.floor(gridWidth / labelWidth); // 275/55 = 5
            const rows = Math.floor(gridHeight / labelHeight);  // 440/110 = 4

            // Toplamda en fazla (columns * rows) etiket sığar
            const maxLabels = columns * rows;
            const labelsToShow = allLabels.slice(0, maxLabels);

            return (
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: `repeat(${columns}, ${labelWidth}mm)`,
                  gridTemplateRows: `repeat(${rows}, ${labelHeight}mm)`,
                  width: `${gridWidth}mm`,
                  height: `${gridHeight}mm`,
                  gap: '0mm',
                  position: 'relative',
                  background: 'white'
                }}
              >
                {labelsToShow.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      width: `${labelWidth}mm`,
                      height: `${labelHeight}mm`,
                      position: 'relative',
                      boxSizing: 'border-box',
                      border: '1px solid gray',
                    }}
                  >
                    {/* Etiket içeriği */}
                    <div style={{ position: 'relative', zIndex: 20}}>
                    {RefCode ? (
                      (() => {
                        const referenceCode = RefCode;
                        const referenceWidth = RefWidth;
                        const sizeData = item.sizeData;
                        const inx = item.inx;

                        if (referenceCode.includes('KALL') && referenceWidth === 50) {
                          return (

                            
                            <div className="printable" style={{ position: 'relative', width: "50mm", height: "102.2mm" }}>
                            <div style={{position:"absolute",top:0,left:0}}>

{CardBackBack ? (
  (() => {
    const referenceCode = RefCode;
    const referenceWidth = RefWidth;

    if (referenceCode.includes("KALL") && referenceWidth === 50) {
      return typeof CardBackBack === "function" ? (
        <CardBackBack width="50mm" height="102mm" />
      ) : (
        <img
          src={CardBackBack}
          alt="SVG Image"
          style={{
            width: "50mm",
            height: "102mm",
          }}
        />
      );
    } else if (referenceCode.includes("KALL") && referenceWidth === 32) {
      return typeof CardBackBack === "function" ? (
        <CardBackBack width="32mm" height="90mm" />
      ) : (
        <img
          src={CardBackBack}
          alt="SVG Image"
          style={{
            width: "32mm",
            height: "90mm",
          }}
        />
      );
    } else if (referenceCode.includes("CALL") && referenceWidth === 50) {
      return typeof CardBackBack === "function" ? (
        <CardBackBack width="50mm" height="102mm" />
      ) : (
        <img
          src={CardBackBack}
          alt="SVG Image"
          style={{
            width: "50mm",
            height: "102mm",
          }}
        />
      );
    } else {
      return (
        <div style={{ width: "50mm", height: "102mm" }}>
          <span>Loading...</span>
        </div>
      );
    }
  })()
) : (
  <></>
)}

</div>
                              <PageKall
                                key={index}
                                selectColor={selectColor}
                                barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.beltLabel[selectColor]?.colorCode}${sizeData.sCode ? sizeData.sCode : ''}`}
                                data={data}
                                referance={referance}
                                SouthAmerica={SouthAmerica}
                                sizeData={sizeData}
                                indo={data?.beltLabel[0]?.sizes}
                                szrgrp={data?.sizeGroup}
                                inx={inx}
                              />
                            </div>
                          );
                        } else if (referenceCode.includes('KALL') && referenceWidth === 32) {
                          return (
                            <div className="printable" style={{ position: 'relative', width: "32.2mm", height: "92.2mm" }}>
                            <div style={{position:"absolute",top:0,left:0}}>

{CardBackBack ? (
  (() => {
    const referenceCode = RefCode;
    const referenceWidth = RefWidth;

    if (referenceCode.includes("KALL") && referenceWidth === 50) {
      return typeof CardBackBack === "function" ? (
        <CardBackBack width="50.2mm" height="102.2mm" />
      ) : (
        <img
          src={CardBackBack}
          alt="SVG Image"
          style={{
            width: "50.2mm",
            height: "102.2mm",
          }}
        />
      );
    } else if (referenceCode.includes("KALL") && referenceWidth === 32) {
      return typeof CardBackBack === "function" ? (
        <CardBackBack width="32.2mm" height="92.2mm" />
      ) : (
        <img
          src={CardBackBack}
          alt="SVG Image"
          style={{
            width: "32.2mm",
            height: "92.2mm",
          }}
        />
      );
    } else if (referenceCode.includes("CALL") && referenceWidth === 50) {
      return typeof CardBackBack === "function" ? (
        <CardBackBack width="50.2mm" height="102.2mm" />
      ) : (
        <img
          src={CardBackBack}
          alt="SVG Image"
          style={{
            width: "50.2mm",
            height: "102.2mm",
          }}
        />
      );
    } else {
      return (
        <div style={{ width: "50mm", height: "102mm" }}>
          <span>Loading...</span>
        </div>
      );
    }
  })()
) : (
  <></>
)}

</div>
                              <PageKallLittle
                                key={index}
                                selectColor={selectColor}
                                barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.beltLabel[selectColor]?.colorCode}${sizeData.sCode ? sizeData.sCode : ''}`}
                                data={data}
                                referance={referance}
                                SouthAmerica={SouthAmerica}
                                sizeData={sizeData}
                                indo={data?.beltLabel[0]?.sizes}
                                szrgrp={data?.sizeGroup}
                                inx={inx}
                              />
                            </div>
                          );
                        } else if (referenceCode.includes('CALL') && referenceWidth === 50) {
                          return (
                            <div className="printable" style={{ position: 'relative', width: "50mm", height: "102.2mm" }}>
                            <div style={{position:"absolute",top:0,left:0}}>

{CardBackBack ? (
  (() => {
    const referenceCode = RefCode;
    const referenceWidth = RefWidth;

    if (referenceCode.includes("KALL") && referenceWidth === 50) {
      return typeof CardBackBack === "function" ? (
        <CardBackBack width="50.2mm" height="102.2mm" />
      ) : (
        <img
          src={CardBackBack}
          alt="SVG Image"
          style={{
            width: "50.2mm",
            height: "102.2mm",
          }}
        />
      );
    } else if (referenceCode.includes("KALL") && referenceWidth === 32) {
      return typeof CardBackBack === "function" ? (
        <CardBackBack width="32.2mm" height="92.2mm" />
      ) : (
        <img
          src={CardBackBack}
          alt="SVG Image"
          style={{
            width: "32.2mm",
            height: "92.2mm",
          }}
        />
      );
    } else if (referenceCode.includes("CALL") && referenceWidth === 50) {
      return typeof CardBackBack === "function" ? (
        <CardBackBack width="50.2mm" height="102.2mm" />
      ) : (
        <img
          src={CardBackBack}
          alt="SVG Image"
          style={{
            width: "50.2mm",
            height: "102.2mm",
          }}
        />
      );
    } else {
      return (
        <div style={{ width: "50mm", height: "102mm" }}>
          <span>Loading...</span>
        </div>
      );
    }
  })()
) : (
  <></>
)}

</div>
                              <Page1
                                key={index}
                                selectColor={selectColor}
                                barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.beltLabel[selectColor]?.colorCode}${sizeData.sCode ? sizeData.sCode : ''}`}
                                data={data}
                                referance={referance}
                                SouthAmerica={SouthAmerica}
                                sizeData={sizeData}
                                indo={data?.beltLabel[0]?.sizes}
                                szrgrp={data?.sizeGroup}
                                inx={inx}
                              />
                            </div>
                          );

                          
                        } else {
                          return null;
                        }
                      })()
                    ) : null}
                    </div>
                  </div>
                ))}
              </div>
            );
          })()
        ) : null}
      </div>
    </div>
  )


}

export default React.forwardRef(BeltKnifeMain)
